import { useTranslation } from "react-i18next";
import { DownOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Col, Pagination, Row, Spin, Typography } from 'antd'
import { PaginationProps } from 'antd/lib'
import { ChangeEvent, KeyboardEvent, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import EmptyComponent from '../../../components/empty'
import FormInput from '../../../components/form-input/FormInput'
import SafeLink from '../../../components/link/SafeLink'
import PageHeader from '../../../components/page-header/PageHeader'
import { routesConfig } from '../../../config/routes'
import { getCourseName } from '../../../service/courses'
import { getEnrollClass } from '../../../service/test-schedule'
import { CourseClass } from '../../../types/course-management'
import { itemRenderPaging } from '../../../utils/functionUltils'
import FormFilter from './components/FormFilter'
import "./style.scss"
import { EnrollClassEnum } from '../../../constants/learing-material'
type Props = {
	title: string
}

interface FilterDataType {
	stars?: number[];
	lecturer?: any[];
	status?: number;
	timeCreated?: any;
}
const { Title } = Typography;

const TestClasses = (props: Props) => {
  const { t } = useTranslation();
	const { courseId, blockId } = useParams();
	const navigate = useNavigate()

	const imgPath = "/images/";
	const [showFilter, setShowFilter] = useState<boolean>(false);
	const [searchValue, setSearchValue] = useState<string>("")
	const [detailData, setDetailData] = useState<any>(null);
	const [listCourseClass, setListCourseClass] = useState<CourseClass[]>([])
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [pageSize, setPageSize] = useState<number>(10)
	const [pageNumber, setPageNumber] = useState<number>(1)
	const [totalPage, setTotalPage] = useState<number>(0)
	const [unitName, setUnitName] = useState<string>("")

	const [filterData, setFilterData] = useState<FilterDataType>({
		lecturer: [],
		status: undefined,
		timeCreated: undefined,
	});

	const fetchEnrollClass = async () => {
		const payload = {
			page: pageNumber,
			size: pageSize,
			keyword: searchValue,
			courseId: Number(courseId),
			blockId: Number(blockId),
			status: filterData?.status,
			teacherIds: filterData?.lecturer
		}
		try {
			setIsLoading(true)
			const res = await getEnrollClass(payload);
			const data = res?.data?.data;
			setListCourseClass(data.content)
			setTotalPage(data.total)
			setUnitName(data?.unitName)
		} catch (error) {

		}
		finally {
			setIsLoading(false)
		}
	}


	useEffect(() => {
		fetchEnrollClass()
	}, [pageSize, pageNumber, filterData])
	const handleOpenFilter = () => {
		setShowFilter(!showFilter);
	};

	useEffect(() => {
		const getDetailCourseData = async () => {
			try {
				await getCourseName(Number(courseId)).then((res) => {
					const { data } = res.data;
					setDetailData(data);
				});
			} catch (error) {

			}
		};
		getDetailCourseData();
	}, [courseId]);

	const listBreadcrumb = [
		{
			title: (
				<SafeLink to={`${routesConfig.scoringListCourse}`}>{t("Danh sách khoá học", "Danh sách khoá học")}</SafeLink>
			),
		},
		{
			title: (
				<SafeLink
					to={`${routesConfig.courseManagement}/${courseId}/${routesConfig.gradingList}`}
				>
					{detailData?.name}
				</SafeLink>
			),
		},
		{
			title: unitName,
		},
	];


	const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		setSearchValue(value);
	};
	const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
		if (e.key === "Enter") {
			fetchEnrollClass()
		}
	};

	const handleSubmitSearch = () => {
		fetchEnrollClass()

	}

	const onChange: PaginationProps['onChange'] = (pageNumber) => {
		setPageNumber(pageNumber);
	};
	const onShowSizeChange: PaginationProps["onShowSizeChange"] = (current, size) => {
		setPageSize(size);
		setPageNumber(1);
	};

	const renderTestScheduleStatus = (status: number) => {
		switch (status) {
			case EnrollClassEnum.NOT_YET_OPEN:
				return t("Chưa mở ghi danh", "Chưa mở ghi danh");
			case EnrollClassEnum.ENROLLING:
				return t("Đang mở ghi danh", "Đang mở ghi danh");
			case EnrollClassEnum.CLOSED_ENROLLING:
				return t("Đóng ghi danh", "Đóng ghi danh");
			case EnrollClassEnum.OPENED:
				return t("Đã khai giảng", "Đã khai giảng");
			case EnrollClassEnum.CLOSED:
				return t("Đã kết thúc", "Đã kết thúc");
			default:
				return "";
		}
	}

	return (
		<div className='test-classes'>
			<PageHeader
				title={unitName}
				subTitle=''
				breadcrumb={true}
				listBreadcrumb={listBreadcrumb}
				arrowLeft={imgPath + 'arrowLeft.svg'}
				positionItem='column'
				headerGroupButton={true}
				childrenGroupButton={
					<div className='button-container'>
						<Button className="filter-button" onClick={handleOpenFilter}>
							<Typography.Text>{t("Bộ lọc", "Bộ lọc")}</Typography.Text>
							<DownOutlined />
						</Button>
						<FormInput
							placeholder={t("Nhập tên lịch kiểm tra", "Nhập tên lịch kiểm tra")}
							value={searchValue}
							onChange={handleChangeInput}
							onKeyPress={handleSearch}
							afterPrefixIcon={<SearchOutlined onClick={handleSubmitSearch} />}
						/>
					</div>
				}
			/>
			{showFilter ? (
				<div className="form-filter">
					<FormFilter
						handleCloseFilter={() => setShowFilter(false)}
						showFilter={showFilter}
						setFilterData={setFilterData}
					/>
				</div>

			) : null}
			<div className="test-class-content">
				{isLoading ? <div className="test-class-loading">
					<Spin />
				</div> :
					<>
						<div className="content">
							{
								listCourseClass?.length > 0 ? <Row gutter={[16, 16]} className="test-schedule-row">
									{listCourseClass?.map((it: CourseClass) => (
										<Col
											key={it?.id}
											className="gutter-row"
											xs={24}
											sm={12}
											md={8}
											lg={8}
											xl={8}
											xxl={8}
											onClick={() => {
												navigate(`${routesConfig.courseManagement}/${courseId}/${routesConfig.grading}/${blockId}/test-classes/${it?.id}/students`,
												)
											}}
										>
											<div className="card-item">
												<Title level={5}>{it?.name}</Title>
												<div>{t("Trạng thái:", "Trạng thái:")} {renderTestScheduleStatus(it?.status)}</div>
												<div>{t("Giảng viên:", "Giảng viên:")} {it?.teachers?.map(tc => tc?.name).join(", ")}</div>
												<div className="flex w-full gap-24">
													<div>{t("Học viên:", "Học viên:")} {it?.studentCount}</div>
													<div>{t("Số buổi:", "Số buổi:")} {it?.numberOfSession || t("Không có", "Không có")}</div>
												</div>
											</div>
										</Col>
									))}
								</Row> : <div className="empty-schedule">
									<EmptyComponent description={t("Chưa có lớp cho học liệu này", "Chưa có lớp cho học liệu này")} />
								</div>
							}
						</div>

						<Pagination
							total={totalPage}
							showSizeChanger
							pageSize={pageSize}
							current={pageNumber}
							className="pagination-table"
							onChange={onChange}
							onShowSizeChange={onShowSizeChange}
							itemRender={itemRenderPaging}
							locale={{
								items_per_page: "/ trang",
								jump_to: t("Đi đến trang", "Đi đến trang"),
								page: "",
							}}
							showQuickJumper
							showTotal={(total) => `${t("Tổng số", "Tổng số")} ${total} ${t("bản ghi", "bản ghi")}`}
						/>
					</>
				}
			</div>
		</div>
	)
}

export default TestClasses   